'use client'
import { WalletProviderEnum } from '@dynamic-labs/sdk-api-core';
import { VerifiedCredentialNameToChainEnum } from '../../constants/values.js';

const findEmbeddedWalletFromVerifiedCredentials = (user, chains) => {
    var _a;
    const verifiedCredentials = (_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.filter(({ walletProvider }) => walletProvider === WalletProviderEnum.EmbeddedWallet);
    if ((verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.length) && (chains === null || chains === void 0 ? void 0 : chains.length)) {
        return verifiedCredentials.find(({ chain }) => chain && chains.includes(VerifiedCredentialNameToChainEnum[chain]));
    }
    return verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.shift();
};

export { findEmbeddedWalletFromVerifiedCredentials };
